import React, { useEffect, useState } from "react";
import { getLocalidades } from "../../../../api/localidad";
import { getCountries } from "../../../../api/country";
import { getProvincias } from "../../../../api/provincia";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import { Col, Row } from "react-bootstrap";
import { Button, Checkbox, createTheme, FormControlLabel, MuiThemeProvider, TextField } from "@material-ui/core";
import MyAutocomplete from "../../../components/MyAutocomplete";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useHistory, useParams } from "react-router-dom";
import { deleteCenter, getCenterById, postCenter, updateCenter } from "../../../../api/center";
import { useSkeleton } from "../../../hooks/useSkeleton";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyCenter() {
    return {
        active: true
    }
}

export default function EditCenterPage() {
    const centerId = useParams().id
    const history = useHistory();
    const [center, setCenter] = useState(getEmptyCenter());
    const [countries, setCountries] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedProvinces, setSelectedProvinces] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(0);
    const [refresh, setRefresh] = useState(null);
    
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()
    
    useEffect(() => {
        setRefresh(false);
    }, [refresh])
    
    useEffect(() => {
        fetch();
    }, [])

    function fetch() {
        getLocalidades()
            .then((res) => {
                setCities(res.data);
            })
            .catch((error) => {
                if (error.request.status !== 404) {
                    alertError({
                        error,
                        customMessage: "No se han podido encontrar las ciudades."
                    })
                }
            })

        getCountries()
            .then((res) => {
                setCountries(res.data);
            })
            .catch((error) => {
                if (error.request.status !== 404) {
                    alertError({
                        error,
                        customMessage: "No se han podido encontrar países."
                    })
                }
            })

        getProvincias()
            .then((res) => {
                setProvinces(res.data);
            })
            .catch((error) => {
                if (error.request.status !== 404) {
                    alertError({
                        error,
                        customMessage: "No se han podido encontrar provincias."
                    })
                }
            })
            
        if (!centerId) { disableLoadingData(); return;}
        getCenterById(centerId)
            .then((res) => {
                const center = res.data;
                if (center?.country) {
                    selectProvinces(center?.country);
                    if (center?.province) {
                        selectCities(center?.province);
                    }
                }
                
                setRefresh(true);
                setCenter(center);
                disableLoadingData();
            })
            .catch((error) => {
                alertError({

                    error,
                    customMessage: "No se ha podido encontrar el centro."
                })
            })
    }

    function saveCenter() {
        if (!center?._id) {
            postCenter(center)
                .then((res) => {
                    alertSuccess({ title: "Éxito!", customMessage: "Center creado correctamente."});
                    history.push("/centers");
                })
                .catch((error) => {
                    alertError({ error, customMessage: "No se ha podido crear el centro"});
                })
            }
            else {
                updateCenter(center._id, center)
                .then((res) => {
                    alertSuccess({ title: "Éxito!", customMessage: "Centro actualizado correctamente."});
                    history.push("/centers");
                })
                .catch((error) => {
                    alertError({ error, customMessage: "No se ha podido actualizar el centro"});
                })
        }
    }

    const handleChange = (element) => (event) => {
        setCenter({ ...center, [element]: event.target.value });
    }

    function selectProvinces(countryId) {
        let newProvinces = [];

        for (let i = 0; i < provinces.length; ++i) {
            const actP = provinces[i];
            if (actP?.pais === countryId) {
                newProvinces.push(actP);
            }
        }

        setSelectedProvinces(newProvinces);
    }

    function selectCities(provinceId) {
        let newCities = [];

        for (let i = 0; i < cities.length; ++i) {
            const actP = cities[i];
            if (actP?.provincia === provinceId) {
                newCities.push(actP);
            }
        }

        setSelectedCities(newCities);
    }

    if (isLoadingData) 
        return (<ContentSkeleton />)
    return (
        <>
            <Card>
                <CardHeader title="Editar centro" />
                <CardBody>
                    <Row>
                        <Col>
                            <TextField
                                label="Nombre"
                                value={center?.fullName}
                                onChange={handleChange("fullName")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <TextField
                                label="Correo electrónico de contacto"
                                value={center?.mail}
                                onChange={handleChange("mail")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                        <Col>
                            <TextField
                                label="Teléfono de contacto"
                                value={center?.phone}
                                onChange={handleChange("phone")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                    </Row>
                    { !refresh && (
                    <Row>
                        <Col>
                            <MyAutocomplete 
                                options={ countries }
                                getOptionLabel={(option) => option.name}
                                value={center?.country}
                                onChange={(event, selected) => {
                                    setCenter({ ...center, country: selected, province: null, city: null });
                                    selectProvinces(selected?._id);
                                    setRefresh(true);
                                }}
                                placeholder="Selecciona el país"
                                label={"País"}
                            />
                        </Col>
                        <Col>
                            <MyAutocomplete 
                                options={ selectedProvinces }
                                getOptionLabel={(option) => option.fullName}
                                value={center?.province}
                                onChange={(event, selected) => {
                                    setCenter({ ...center, province: selected, city: null });
                                    selectCities(selected?._id);
                                    setRefresh(true);
                                }}
                                placeholder="Selecciona la provincia"
                                label={"Provincia"}
                            />
                        </Col>
                        <Col>
                            <MyAutocomplete 
                                options={ selectedCities }
                                getOptionLabel={(option) => option.fullName}
                                value={center?.city}
                                onChange={(event, selected) => {
                                    setCenter({ ...center, city: selected})
                                }}
                                placeholder="Seleccion la ciudad"
                                label={"Ciudad"}
                            />
                        </Col>
                    </Row>
                    )}
                    <Row>
                        <Col>
                            <TextField
                                label="Dirección"
                                value={center?.address}
                                onChange={handleChange("address")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormControlLabel
                                control={<Checkbox checked={center?.active} onChange={() => setCenter({ ...center, active: !center?.active })} name="checkActive" />}
                                label="Activo"
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/centers')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Atrás
            </Button>
            <Button
                onClick={() => saveCenter()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Guardar centro
            </Button>
            {center?._id && <>
                <MuiThemeProvider theme={theme}>
                <Button
                    onClick={() => setOpenConfirmDialog(true)}
                    variant="outlined"
                    color="secondary">
                    Eliminar centro
                </Button>
                </MuiThemeProvider>

                <ConfirmDialog
                title={'Seguro que quieres eliminar este centro?'}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteCenter(center._id)
                        .then((res) => {
                            alertSuccess({ title: "Éxito!", customMessage: "Centro eliminado correctamente." });
                            history.push("/centers");
                        })
                        .catch((error) => {
                            alertError({ error, customMessage: "No se ha podido eliminar el centro." });
                        })
                }}
                />
      </>}
        </>
    )
}